import { StyleSheet, TextStyle, View } from "react-native";
import Text from "./Text";
import { BodyMediumText } from "./FormattedText";
import { useTheme } from "../hooks/use-theme";

type LabelValueTextProps = {
    label: string;
    value: string;
    textStyle?: TextStyle;
    subValues?: { label: string; value: string }[];
    valueStyle?: TextStyle;
};

export const LabelValueText = ({
    label,
    value,
    textStyle,
    subValues = [],
    valueStyle,
}: LabelValueTextProps) => {
    const styles = useStyles();

    return (
        <>
            <View style={styles.wrapper}>
                <BodyMediumText style={StyleSheet.flatten([styles.labelText, textStyle])}>
                    {label}
                </BodyMediumText>
                <BodyMediumText style={valueStyle || textStyle}>{value}</BodyMediumText>
            </View>
            {subValues?.map((v, i) => (
                <LabelValueText key={i} {...v} textStyle={styles.subValueText} />
            ))}
        </>
    );
};

const useStyles = () => {
    const { fonts, colors } = useTheme();

    return StyleSheet.create({
        wrapper: {
            alignItems: "flex-end",
            flexDirection: "row",
            justifyContent: "space-between",
        },
        labelText: {
            flex: 1,
        },
        subValueText: {
            ...fonts.bodySmall,
            color: colors.greyAccessible,
        },
    });
};

export default LabelValueText;
